'use client'
import { LineEmail } from '@qr-front/icons/line-email'
import { InputField } from '@qr-front/ui/components/InputField'
import { EMAIL_MAX_LENGTH, EMAIL_REGEX } from 'constants/validationConstants'
import { useTranslations } from 'next-intl'
import { Controller, useFormContext } from 'react-hook-form'

type InputFieldEmailFormProps = {
	name?: string
	placeholder?: string
	value?: string
	onChange?: (value: string) => void
	onBlur?: () => void
	label?: string
	ariaLabel?: string
	className?: string
	leftIcon?: React.ComponentType<{ className?: string }> | null
	readOnly?: boolean
    autoComplete?: React.HTMLInputAutoCompleteAttribute
}

export const InputFieldEmailForm: React.FC<InputFieldEmailFormProps> = ({
	name = 'email',
	placeholder,
	value,
	onChange,
	onBlur,
	label,
	ariaLabel,
	className,
	leftIcon = LineEmail,
	readOnly,
	autoComplete,
}) => {
	const form = useFormContext()
	const t = useTranslations()

	return (
		<Controller
			control={form.control}
			name={name}
			rules={{
				required: t('auth__common__input_login_validation__required'),
				pattern: {
					value: EMAIL_REGEX,
					message: t('auth__common__input_login_validation__invalid'),
				},
				maxLength: {
					value: EMAIL_MAX_LENGTH,
					message: '',
				},
			}}
			render={({ field, fieldState }) => {
				const errorMessage = fieldState.error?.message || undefined

				return (
					<InputField
						{...field}
						id={name}
						leftIcon={leftIcon}
						placeholder={
							placeholder ??
							t('auth__common__input_login_placeholder')
						}
						type={name}
						error={errorMessage}
						maxLength={EMAIL_MAX_LENGTH}
						value={value ?? field.value}
						onChange={(e) => {
							field.onChange(e)
							onChange?.(e.target.value)
						}}
						onBlur={() => {
							field.onBlur()
							onBlur?.()
						}}
						label={label}
						aria-label={ariaLabel}
						className={className}
						readOnly={readOnly}
						autoComplete={autoComplete}
					/>
				)
			}}
		/>
	)
}
